import {Component,ViewEncapsulation} from '@angular/core';

import { Router } from '@angular/router';
declare var $:any;//Required for jquery use
@Component({
  selector: 'site-footer',
  templateUrl: './siteFooter.component.html',
 
  encapsulation:ViewEncapsulation.None,
 
})
export class SiteFooterComponent  {

  constructor(private _router: Router){

  }










ngAfterViewInit(){

//scrolltotop
	      $(window).scroll(function(){
				if ($(this).scrollTop() > 1) {
					$('#yt-totop').css({bottom:"25px"});
				} else {
				$('#yt-totop').css({bottom:"-50px"});
				}
			});
			
			$('#yt-totop').click(function(){
				$('html, body').animate({scrollTop: '0px'}, 800);
					return false;
			});




}


}
